module.exports = __webpack_public_path__ + "47c9a4102db98f49d304495aeccca53f.png";